var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-226.781 -96.541)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(226.781 96.541)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6a92c5",
    d: "M164.6,151.478a3.668,3.668,0,1,1,3.9-3.661A3.79,3.79,0,0,1,164.6,151.478Zm0-6.554a2.9,2.9,0,1,0,3.081,2.893A2.995,2.995,0,0,0,164.6,144.924Zm0,0",
    transform: "translate(-157.603 -141.685)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6a92c5",
    d: "M227.432,212l.507-.507a.384.384,0,0,0-.543-.543l-.507.507-.507-.507a.384.384,0,0,0-.543.543l.507.507-.507.507a.384.384,0,1,0,.543.543l.507-.507.507.507a.384.384,0,1,0,.543-.543Zm0,0",
    transform: "translate(-219.889 -205.806)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6a92c5",
    d: "M87,94a.4.4,0,0,1-.326-.164l-1.362-1.878H81.993A1.959,1.959,0,0,1,80,90.035V81.923A1.959,1.959,0,0,1,81.993,80H83.04c.22,0,.22.769,0,.769H81.993A1.175,1.175,0,0,0,80.8,81.923v8.112a1.175,1.175,0,0,0,1.193,1.154h3.53a.4.4,0,0,1,.326.164L87,92.946l1.156-1.593a.4.4,0,0,1,.326-.164h3.53a1.175,1.175,0,0,0,1.193-1.154V81.923a1.175,1.175,0,0,0-1.193-1.154H82.659c-.22,0-.22-.769,0-.769h9.356A1.959,1.959,0,0,1,94,81.923v8.112a1.959,1.959,0,0,1-1.989,1.923H88.692l-1.363,1.878A.4.4,0,0,1,87,94Zm0,0",
    transform: "translate(-80.004 -80)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteMessage);
export default __webpack_public_path__ + "static/media/deleteMessage.c33de0d8.svg";
export { ForwardRef as ReactComponent };